import Head from "next/head";
import React from "react";
import styles from "../styles/companies.module.scss";
import Hero from "../components/Agentic/Hero/Hero";
import Agentic from "../components/Agentic/Agentic/Agentic";
import FeaturesSection from "../components/Agentic/FeaturesSection/FeaturesSection";
import BenefitsSection from "../components/Agentic/BenefitSection/BenefitSection";
import Cta from "../components/Agentic/CTA/Cta";
import Works from "../components/Agentic/Works/Works";
import AiFeatures from "../components/Agentic/AiFeatures/AiFeatures";
import BusinessImpact from "../components/Agentic/BussinessImpact/BusinessImpact";
import WorksEverywhere from "../components/Agentic/WorksEverywhere/WorksEverywhere";
import SuccessStories from "../components/Agentic/SuccessStories/SuccessStories";
import ArchitectureSection from "../components/Agentic/ArchitectureSection/ArchitectureSection";
function AgenticCommerce() {
  return (
    <>
      <Head>
        <title>Agentic Commerce | Socommerz</title>
        <meta name="title" content="Agentic Commerce | Socommerz" />
        <meta
          name="description"
          content="Revolutionize e-commerce with AI-powered shopping assistants. Socommerz empowers agentic commerce to deliver personalized customer experiences at scale."
        />
        <meta
          name="keywords"
          content="Agentic Commerce, AI Shopping Assistant, Socommerz, E-commerce AI, B2B Technology, Startup Incubator, Autonomous Shopping, Personalized Commerce"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph Meta Tags */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.socommerz.com/agentic-commerce/"
        />
        <meta property="og:title" content="Agentic Commerce | Socommerz" />
        <meta
          property="og:description"
          content="Discover how Socommerz is redefining e-commerce with autonomous AI shopping assistants and intelligent commerce infrastructure."
        />
        <meta
          property="og:image"
          content="https://www.socommerz.com/og-image.jpg"
        />

        {/* Twitter Meta Tags */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://www.socommerz.com/agentic-commerce/"
        />
        <meta property="twitter:title" content="Agentic Commerce | Socommerz" />
        <meta
          property="twitter:description"
          content="Experience the future of commerce. AI-powered, customer-centric, and scalable—only with Socommerz."
        />
        <meta
          property="twitter:image"
          content="https://www.socommerz.com/twitter-image.jpg"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.socommerz.com/agentic-commerce/"
        />
        <link
          rel="alternate"
          href="https://www.socommerz.com/agentic-commerce/"
          hrefLang="en-in"
        />
      </Head>

      <main>
        {/* <div className={styles["main-wrapper"]}> */}
        <Hero />
        <ArchitectureSection/>
        <FeaturesSection />
        <Works />
        <AiFeatures />
        <SuccessStories />
        <WorksEverywhere />
        <BenefitsSection />
        {/* <BusinessImpact /> */}
        <Agentic />
        <Cta />
        {/* </div> */}
      </main>
    </>
  );
}

export default AgenticCommerce;
